import { useState, useEffect } from "react";
import "../theme/Administracion.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import { authProvider } from "../context/authProvider";
import { UseAdmin, UseUser } from "../hooks";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { useNavigate, useLocation } from "react-router-dom";
import { VERSION_APP } from "../utilities";
import { fetchSecciones } from "../Api/fetchSecciones";

import { normalize } from "../utils/util";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import { useColoresEmpresa } from "../hooks/useColoresEmpresa";
import { ModuleCard } from "../components/shared/ModuleCard";
import { ModuleHeader } from "../components/shared/ModuleHeader";

export const AdminPage = () => {
  useColoresEmpresa();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [adminData, setAdminData] = useState(null);
  const { jobTitle } = UseUser();
  const { branchFiSucursalId, brandfiMarcaId, branchFiPaisId, rolId } = UseAdmin();

  useEffect(() => {
    getDataSeccion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchFiPaisId, brandfiMarcaId, jobTitle, branchFiSucursalId, rolId]);

  const getDataSeccion = () => {
    if (
      branchFiPaisId !== null &&
      branchFiSucursalId !== null &&
      brandfiMarcaId !== null &&
      jobTitle !== null &&
      rolId !== null
    ) {
      const onFailure = ({ error }) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
        setLoading(false);
      };

      const onSuccess = ({ data }) => {
        const secciones = data.body.seccion.CHILD1 || [];
        const admin2 = secciones.find(
          (sec) => normalize(sec.FCSEGUNDASECCION) === "administracion"
        );

        const adminData = admin2?.CHILD2 ?? [];
        setAdminData(adminData);
        setLoading(false);
      };

      fetchSecciones(
        branchFiPaisId,
        brandfiMarcaId,
        jobTitle,
        branchFiSucursalId,
        VERSION_APP,
        Number(rolId)
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const navigateToFuncionOnRouter = (url, child2) => {
    navigate(`/${url}`);
  };

  const handleClickLink = (itemPress, urlPress) => {
    if (itemPress === "navigateToFuncionOnRouter") {
      navigateToFuncionOnRouter(urlPress);
    }
  };

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin border-none">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption={state.dataRouter[0].FCSEGUNDASECCION} />
                </div>
              </div>

              <div>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <>
                    <ModuleHeader
                      title="Administración"
                      subtitle="Seleccione un módulo para continuar"
                    />

                    <div className="admin-grid-container">
                      <div className="admin-grid">
                        {adminData.map((item) => (
                          <ModuleCard
                            key={item.FITERCERASECCION}
                            item={item}
                            onClick={() =>
                              handleClickLink(item.FCJSONSECCION3, item.FCLINKSECCION3)
                            }
                          />
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
